/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { TipoPraticaAttributoDTO } from './tipo-pratica-attributo-dto';


export interface PagedModelTipoPraticaAttributoDTO { 
    content?: Array<TipoPraticaAttributoDTO>;
    page?: PageMetadata;
}

